import PropTypes from 'prop-types'
import React, { useContext, useEffect, useState } from 'react'
import { FaTrashAlt } from 'react-icons/fa'

import { Grid, LinearProgress } from '@material-ui/core'
import { MdPerson, MdPhone } from 'react-icons/md'
import { getPartnersList, getSearch, publishPartner } from '../../services/ClubeApi'
import { getLoggedUser, isAuthenticated } from '../../services/auth'

import changeLogo from '../../assets/images/altera-logo.png'

import Context from '../../context'
import history from '../../services/history'

import TopSearch from '../../components/TopSearch'
// import ProgressBar from '../../components/ProgressBar';
import DeleteModal from '../../components/DeleteModal'
import PaginationComponent from '../../components/PaginationComponent'
import PhoneFormat from '../../components/PhoneFormat'
import ToastMessages from '../../components/ToastMessages'

function PartnersList({ location }) {
  const { state } = location
  const { user, setUser, setAboutCurrentPage, setEditPartner, setPartnerToEdit, setOpenToast } =
    useContext(Context)

  const [searchData, setSearchData] = useState({ str: '', startSearch: false })
  const [page, setPage] = useState(0)
  const [totalPages, setTotalPages] = useState(5)
  const [fullPartnerList, setFullPartnerList] = useState([])
  const [partnerList, setPartnerList] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [filter, setFilter] = useState(0)
  const [tempList, setTempList] = useState([])
  const [isFiltered, setIsFiltered] = useState(false)
  const [publicLoading, setPublicLoading] = useState({
    loading: false,
    objectId: 0
  })

  const [modalData, setModalData] = useState({
    type: 'Parceiro',
    title: '',
    id: 0
  })

  const listUpdate = async () => {
    setIsLoading(true)
    const actualPage = page || 1
    return getPartnersList(actualPage, 16)
  }

  useEffect(() => {
    if (user) {
      if (isAuthenticated) {
        setUser(getLoggedUser)
      } else {
        history.replace('/')
      }

      setAboutCurrentPage({
        title: 'Parceiros',
        buttons: [
          {
            title: 'Adicionar Parceiro',
            pathname: '/partnerform'
          }
        ]
      })
      listUpdate()
        .then(res => {
          const { pagination } = res
          setFullPartnerList(res.data)

          setPage(pagination.page || 1)
          setTotalPages(pagination.totalPages || 1)
          setIsLoading(false)
        })
        .catch(error => {
          console.log('error', error)
        })

      setPartnerToEdit({})

      if (state && state.showToast) {
        setOpenToast({
          open: true,
          message: state.toastMessage,
          type: 'success'
        })
      } else {
        setOpenToast({
          open: false,
          message: '',
          type: 'success'
        })
      }
    }
  }, [])
  useEffect(() => {
    if (searchData.startSearch && user) {
      setIsLoading(true)
      getSearch('partner', searchData.str, user?.userGroup).then(r => {
        setPartnerList(r)
        setSearchData({ ...searchData, startSearch: false })
        setIsLoading(false)
      })
    }

    if (!searchData.startSearch && searchData.str === '') {
      setPartnerList(fullPartnerList)
    }
  }, [searchData])

  useEffect(() => {
    if (user) {
      listUpdate().then(r => {
        const { data } = r

        setFullPartnerList(data)
        setIsLoading(false)
      })
    }
  }, [page, user])

  useEffect(() => {
    if (fullPartnerList && fullPartnerList.length > 0) {
      setPartnerList(fullPartnerList)
    }
  }, [fullPartnerList])

  const checkLoading = id => {
    return publicLoading.loading && publicLoading.objectId === id
  }

  const handlePartnerClick = partnerId => {
    setUser({ ...user, partnerId })
    setEditPartner({ id: partnerId })
    history.push('/unitieslist')
  }

  const handlePublicClick = async id => {
    setPublicLoading({ loading: true, objectId: id })
    const itemToChange = partnerList.find(item => item.id === id)
    const active = await publishPartner(
      itemToChange.id,
      itemToChange.situation === 3 ? 1 : 3
    )

    if (active.message === 'Atualizado com sucesso') {
      setPartnerList(list => {
        return list.map(item => {
          if (item.id === id) {
            const situation = item.situation === 3 ? 1 : 3
            return { ...item, situation }
          }
          return item
        })
      })

      setPublicLoading({ loading: false, objectId: 0 })
      setOpenToast({
        open: true,
        message: 'Parceiro atualizado com sucesso',
        type: 'success'
      })
    } else {
      setOpenToast({
        open: true,
        message: 'Ocorreu algum erro ao atualizar.',
        type: 'error'
      })
    }
  }

  const handleSelectFilter = value => {
    const listToFilter = isFiltered ? tempList : fullPartnerList
    let newList = []
    switch (value) {
      case '1':
        setFilter(1)
        newList = listToFilter.filter(item => {
          return item.situation === 1
        })
        setPartnerList([...newList])
        break
      case '2':
        setFilter(3)
        newList = listToFilter.filter(item => {
          return item.situation === 3
        })
        setPartnerList([...newList])
        break

      default:
        setFilter(0)
        setPartnerList(listToFilter)
        break
    }
  }

  const handleSearch = str => {
    if (str.length >= 3) {
      setIsFiltered(true)
      const newList = fullPartnerList.filter(item => {
        return !filter
          ? item.fantasyName.toLowerCase().includes(str.toLowerCase())
          : item.fantasyName.toLowerCase().includes(str.toLowerCase()) && item.situation === filter
      })
      setTempList(newList)
      setPartnerList(newList)
    } else {
      setIsFiltered(false)
    }
    if (str.length === 0) {
      setIsFiltered(false)
      if (filter !== 0) {
        const newList = fullPartnerList.filter(item => {
          return item.situation === filter
        })
        setTempList(newList)
        setPartnerList(newList)
      } else {
        setTempList(fullPartnerList)
        setPartnerList(fullPartnerList)
      }
    }
  }

  const handleDelete = () => {
    setIsLoading(true)
    publishPartner(modalData.id, 2).then(r => {
      if (r && r.message === 'Atualizado com sucesso') {
        setPartnerList(list => {
          return list.filter(item => {
            return item.id !== modalData.id
          })
        })

        setIsLoading(false)
        setOpenToast({
          open: true,
          message: 'Parceiro Deletado com Sucesso',
          type: 'success'
        })
      } else {
        setIsLoading(false)
        setOpenToast({
          open: true,
          message: 'Ops... Ocorreu algum erro ao Deletar',
          type: 'error'
        })
      }
    })
  }

  return (
    <Grid container style={{ padding: 15 }}>
      <Grid item xs={12}>
        <ToastMessages />
        <Context.Provider value={{ searchData, setSearchData }}>
          <TopSearch
            // buttonLabel="Adicionar Parceiro"
            // goTo="/partnerform"
            searchAction={handleSearch}
            showFilter
            filterAction={handleSelectFilter}
          />
        </Context.Provider>
      </Grid>
      <Grid item xs={12}>
        {isLoading ? (
          <LinearProgress marginTop="30px" />
        ) : (
          <div className="row">
            {partnerList.length > 0 &&
              partnerList.map(partner => (
                <div
                  key={partner.id}
                  className="col-lg-3 col-md-6 col-sm-12"
                  style={{ padding: 10 }}
                >
                  <div className="card card-clube">
                    <img
                      className="card-img-top "
                      src={
                        partner.logo !== ''
                          ? process.env.REACT_APP_IMAGES_URL + partner.logo
                          : changeLogo
                      }
                      alt={partner.name}
                    />
                    <div className="card-body">
                      <h4
                        className="card-title w-100 d-flex justify-content-between align-content-center"
                        style={{ minHeight: 60 }}
                      >
                        {partner.fantasyName}{' '}
                        {partner.situation === 3 && (
                          <small style={{ fontSize: 12, color: 'red' }}>Rascunho</small>
                        )}
                        {partner.situation === 1 && (
                          <small style={{ fontSize: 12, color: 'green' }}>Publicado</small>
                        )}
                      </h4>

                      <div style={{ minHeight: 70 }}>
                        {partner.fullNameContact !== '' && (
                          <p>
                            <MdPerson style={{ marginRight: 10 }} />
                            {partner.fullNameContact || ''}
                          </p>
                        )}
                        {partner.phoneNumberContact !== '' && (
                          <p>
                            <MdPhone style={{ marginRight: 10 }} />
                            <PhoneFormat phone={partner.phoneNumberContact || ''} />
                          </p>
                        )}
                      </div>
                    </div>

                    <div className="card-body d-flex align-content-center justify-content-end flex-grow-0 ">
                      <button
                        className=" btn btn-danger "
                        type="button"
                        onClick={() =>
                          setModalData({
                            id: partner.id,
                            title: partner.fantasyName
                          })
                        }
                        data-toggle="modal"
                        data-target="#deleteModal"
                        style={{ marginLeft: -5 }}
                      >
                        <FaTrashAlt />
                      </button>
                    </div>

                    <div className="card-body d-flex align-content-center justify-content-between flex-grow-0 ">
                      <button
                        disabled={checkLoading(partner.id)}
                        className={`card-link btn ${
                          partner.situation === 3 ? 'btn-success' : 'btn-danger'
                        }`}
                        onClick={() => handlePublicClick(partner.id)}
                        type="button"
                      >
                        {partner.situation === 3 ? 'Publicar' : 'Desativar'}
                      </button>

                      <button
                        className=" card-link btn clube-btn clube-blue "
                        type="button"
                        onClick={() => handlePartnerClick(partner.id)}
                      >
                        Unidades
                      </button>
                    </div>
                    {checkLoading(partner.id) && <LinearProgress marginTop="10px" />}
                  </div>
                </div>
              ))}
          </div>
        )}
      </Grid>
      <Grid item xs={12}>
        <Context.Provider value={{ page, setPage, totalPages }}>
          <PaginationComponent />
        </Context.Provider>
      </Grid>

      <Context.Provider value={{ modalData }}>
        <DeleteModal handleDelete={handleDelete} />
      </Context.Provider>
    </Grid>
  )
}

PartnersList.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string,
    state: PropTypes.object
  }).isRequired
}

export default PartnersList
